var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadDocIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#C7222A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.5V22.5H17L24 15.5L31 22.5H27V28.5H21ZM17 32.5V30.5H31V32.5H17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocIcon);
export default __webpack_public_path__ + "static/media/upload-doc-icon.888b9072a4d50cb76cc69a5791770222.svg";
export { ForwardRef as ReactComponent };